var _path, _path2, _path3, _circle, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 256h512v85.337H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 341.337h512v85.326H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 59.359,
  fill: "#ffda44"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M256 295.304c-21.098 0-38.261-17.163-38.261-38.261v-22.957c0-21.098 17.163-38.261 38.261-38.261s38.261 17.163 38.261 38.261v22.957c0 21.098-17.163 38.261-38.261 38.261z",
  fill: "#338af3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M317.217 165.217h-45.913c0-8.451-6.853-15.304-15.304-15.304s-15.304 6.853-15.304 15.304h-45.913c0 8.452 7.363 15.304 15.814 15.304h-.51c0 8.452 6.852 15.304 15.304 15.304 0 8.452 6.852 15.304 15.304 15.304h30.609c8.452 0 15.304-6.852 15.304-15.304 8.452 0 15.304-6.852 15.304-15.304h-.51c8.453 0 15.815-6.852 15.815-15.304z"
})));

export default SvgEc;